<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- 代码生成器对话框 -->
            <el-dialog
              :title="codeDialogTitle"
              :visible.sync="codeDialogVisible"
              width="80%"
              :before-close="handleCodeDialogClose"
            >
              <el-tabs v-model="activeCodeTab" type="card">
                <el-tab-pane label="cURL" name="curl">
                  <pre class="code-block"><code>{{ generatedCode.curl }}</code></pre>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-document-copy"
                    @click="copyCode('curl')"
                    style="margin-top: 10px;"
                  >复制代码</el-button>
                </el-tab-pane>
                <el-tab-pane label="PHP" name="php">
                  <pre class="code-block"><code>{{ generatedCode.php }}</code></pre>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-document-copy"
                    @click="copyCode('php')"
                    style="margin-top: 10px;"
                  >复制代码</el-button>
                </el-tab-pane>
                <el-tab-pane label="Python" name="python">
                  <pre class="code-block"><code>{{ generatedCode.python }}</code></pre>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-document-copy"
                    @click="copyCode('python')"
                    style="margin-top: 10px;"
                  >复制代码</el-button>
                </el-tab-pane>
              </el-tabs>
            </el-dialog>

            <div class="openapi-container">
              <div id="swagger-ui" class="swagger-ui-wrapper"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { generateCodeFromRequest } from "@/utils/codeGenerator";

export default {
  page() {
    return {
      title: this.$t("menuitems.doc.openapi"),
      meta: [{ name: "description", content: "OpenAPI文档" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "OpenAPI文档",
      items: [
        {
          text: this.$t("dashboard.text"),
          href: "/",
        },
        {
          text: this.$t("menuitems.doc.openapi"),
          active: true,
        },
      ],
      codeDialogVisible: false,
      codeDialogTitle: "生成代码示例",
      activeCodeTab: "curl",
      generatedCode: {
        curl: "",
        php: "",
        python: "",
      },
      currentRequest: null,
    };
  },
  mounted() {
    this.title = this.$t("menuitems.doc.openapi");
    this.items = [
      {
        text: this.$t("dashboard.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.doc.openapi"),
        active: true,
      },
    ];

    // 动态加载Swagger UI
    this.loadSwaggerUI();
  },
  methods: {
    loadSwaggerUI() {
      // 检查是否已加载
      if (window.SwaggerUIBundle) {
        this.initSwaggerUI();
        return;
      }

      // 加载CSS
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui.css";
      document.head.appendChild(link);

      // 加载JS
      const script1 = document.createElement("script");
      script1.src = "https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui-bundle.js";
      script1.onload = () => {
        const script2 = document.createElement("script");
        script2.src = "https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui-standalone-preset.js";
        script2.onload = () => {
          this.initSwaggerUI();
        };
        document.body.appendChild(script2);
      };
      document.body.appendChild(script1);
    },
    initSwaggerUI() {
      // 获取API基础URL
      // 如果是在开发环境，使用当前域名；生产环境使用配置的API地址
      let apiBaseUrl = window.location.origin;
      
      // 检查是否有配置的API基础URL
      if (process.env.VUE_APP_API_BASE_URL) {
        apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      } else {
        // 默认使用当前域名
        apiBaseUrl = window.location.origin;
      }
      
      const openapiUrl = `${apiBaseUrl}/openapi.json`;

      // 获取当前用户的访问令牌（如果有）
      const accessToken = localStorage.getItem("access_token");


      // 初始化Swagger UI
      const ui = window.SwaggerUIBundle({
        url: openapiUrl,
        dom_id: "#swagger-ui",
        deepLinking: true,
        presets: [
          window.SwaggerUIBundle.presets.apis,
          window.SwaggerUIStandalonePreset,
        ],
        plugins: [
          window.SwaggerUIBundle.plugins.DownloadUrl,
        ],
        layout: "StandaloneLayout",
        validatorUrl: null,
        docExpansion: "list",
        filter: true,
        tryItOutEnabled: true,
        requestInterceptor: (request) => {
          // 如果有访问令牌，自动添加到请求头
          if (accessToken && !request.headers.Authorization) {
            request.headers.Authorization = `Bearer ${accessToken}`;
          }
          // 保存当前请求用于代码生成
          this.currentRequest = request;
          return request;
        },
        onComplete: () => {
          // Swagger UI加载完成后的回调
          console.log("Swagger UI loaded successfully");
          
          // 如果有访问令牌，自动填充到认证输入框
          if (accessToken) {
            setTimeout(() => {
              // 尝试自动填充Bearer Token
              const authInputs = document.querySelectorAll('input[placeholder*="Bearer"]');
              if (authInputs.length > 0) {
                authInputs[0].value = accessToken;
                // 触发change事件
                const event = new Event('input', { bubbles: true });
                authInputs[0].dispatchEvent(event);
              }
            }, 1000);
          }
          
          // 为每个操作添加代码生成按钮
          this.addCodeGeneratorButtons();
        },
      });

      // 自定义样式以融入前端主题
      this.applyCustomStyles();
      
      // 保存ui实例供后续使用
      this.swaggerUI = ui;
    },
    addCodeGeneratorButtons() {
      // 为每个操作添加代码生成按钮
      const addButtons = () => {
        const opblocks = document.querySelectorAll('.opblock');
        opblocks.forEach((opblock) => {
          // 检查是否已经添加了按钮
          if (opblock.querySelector('.btn-generate-code')) {
            return;
          }
          
          // 等待opblock-body加载
          const checkBody = setInterval(() => {
            const opblockBody = opblock.querySelector('.opblock-body');
            if (opblockBody) {
              clearInterval(checkBody);
              
              // 创建按钮容器
              const buttonContainer = document.createElement('div');
              buttonContainer.className = 'code-generator-container';
              
              // 创建按钮
              const button = document.createElement('button');
              button.className = 'btn-generate-code';
              button.textContent = '📋 生成代码示例';
              
              // 绑定点击事件
              button.addEventListener('click', () => {
                this.handleGenerateCodeFromOpblock(opblock);
              });
              
              buttonContainer.appendChild(button);
              opblockBody.appendChild(buttonContainer);
            }
          }, 100);
          
          // 10秒后停止检查
          setTimeout(() => clearInterval(checkBody), 10000);
        });
      };
      
      // 立即执行一次
      addButtons();
      
      // 延迟执行，确保DOM完全加载
      setTimeout(addButtons, 2000);
      
      // 监听DOM变化，动态添加按钮
      const observer = new MutationObserver(() => {
        addButtons();
      });
      
      const swaggerContainer = document.getElementById('swagger-ui');
      if (swaggerContainer) {
        observer.observe(swaggerContainer, {
          childList: true,
          subtree: true,
        });
      }
    },
    handleGenerateCodeFromOpblock(opblock) {
      // 从opblock提取请求信息
      const method = opblock.getAttribute('data-method') || 'GET';
      
      // 尝试从多个位置提取路径
      let path = opblock.querySelector('.opblock-summary-path')?.textContent?.trim() || '';
      
      // 如果从summary中提取不到，尝试从请求URL中提取
      if (!path) {
        const requestUrl = opblock.querySelector('.request-url')?.textContent?.trim() || '';
        if (requestUrl) {
          // 从完整URL中提取路径部分
          try {
            const urlObj = new URL(requestUrl);
            path = urlObj.pathname;
          } catch (e) {
            // 如果不是完整URL，直接使用
            path = requestUrl;
          }
        }
      }
      
      // 如果还是提取不到，尝试从Swagger UI的请求对象中获取
      if (!path && this.swaggerUI) {
        // 这里可以尝试从Swagger UI实例中获取当前操作的路径
        const opblockId = opblock.getAttribute('id');
        if (opblockId) {
          // 尝试从opblock-id中提取路径信息
          const pathMatch = opblockId.match(/operations-([^-]+)/);
          if (pathMatch) {
            path = `/${pathMatch[1]}`;
          }
        }
      }
      
      // 确保path以/开头（OpenAPI规范中的路径已经包含/api前缀）
      if (path && !path.startsWith('/')) {
        path = `/${path}`;
      }
      
      // 如果path为空，使用默认路径
      if (!path) {
        path = '/api/domains'; // 默认路径
      }
      
      // 获取API基础URL
      let apiBaseUrl = window.location.origin;
      if (process.env.VUE_APP_API_BASE_URL) {
        apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      }
      
      // 拼接完整URL（path已经包含/api前缀）
      const url = `${apiBaseUrl}${path}`;
      
      // 获取请求头
      const headers = {};
      const accessToken = localStorage.getItem('access_token');
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }
      headers['Content-Type'] = 'application/json';
      
      // 获取请求体（如果有）
      let body = null;
      const bodyTextarea = opblock.querySelector('textarea[data-name="body"]');
      if (bodyTextarea && bodyTextarea.value) {
        try {
          body = JSON.parse(bodyTextarea.value);
        } catch (e) {
          body = bodyTextarea.value;
        }
      }
      
      const request = {
        method: method.toLowerCase(),
        url: url,
        headers: headers,
        body: body,
      };
      
      this.generateAndShowCode(request);
    },
    handleGenerateCode(props) {
      // 从props提取请求信息
      const operation = props.operation || {};
      const method = operation.get('method') || 'GET';
      let path = operation.get('path') || '';
      
      // 确保path以/开头（OpenAPI规范中的路径已经包含/api前缀）
      if (path && !path.startsWith('/')) {
        path = `/${path}`;
      }
      
      // 获取API基础URL
      let apiBaseUrl = window.location.origin;
      if (process.env.VUE_APP_API_BASE_URL) {
        apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      }
      
      // 拼接完整URL（path已经包含/api前缀）
      const url = `${apiBaseUrl}${path}`;
      
      // 获取请求头
      const headers = {};
      const accessToken = localStorage.getItem('access_token');
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }
      headers['Content-Type'] = 'application/json';
      
      const request = {
        method: method.toLowerCase(),
        url: url,
        headers: headers,
        body: null,
      };
      
      this.generateAndShowCode(request);
    },
    generateAndShowCode(request) {
      // 生成各种语言的代码
      try {
        this.generatedCode.curl = generateCodeFromRequest(request, 'curl');
        this.generatedCode.php = generateCodeFromRequest(request, 'php');
        this.generatedCode.python = generateCodeFromRequest(request, 'python');
        this.codeDialogVisible = true;
      } catch (error) {
        console.error('生成代码失败:', error);
        this.$message.error('生成代码失败: ' + error.message);
      }
    },
    copyCode(language) {
      const code = this.generatedCode[language];
      if (!code) return;
      
      // 创建临时文本区域
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      
      try {
        document.execCommand('copy');
        this.$message.success('代码已复制到剪贴板');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      
      document.body.removeChild(textarea);
    },
    handleCodeDialogClose() {
      this.codeDialogVisible = false;
      this.activeCodeTab = 'curl';
    },
    applyCustomStyles() {
      // 添加自定义样式以融入前端主题
      const style = document.createElement("style");
      style.textContent = `
        .swagger-ui-wrapper {
          background: #fff;
          border-radius: 4px;
        }
        .swagger-ui .topbar {
          display: none;
        }
        .swagger-ui .info {
          margin: 20px 0;
        }
        .swagger-ui .scheme-container {
          background: #f8f9fa;
          padding: 15px;
          border-radius: 4px;
          margin: 20px 0;
        }
        .swagger-ui .opblock.opblock-post {
          border-color: #28a745;
          background: #f8fff9;
        }
        .swagger-ui .opblock.opblock-get {
          border-color: #007bff;
          background: #f0f8ff;
        }
        .swagger-ui .opblock.opblock-put {
          border-color: #ffc107;
          background: #fffef0;
        }
        .swagger-ui .opblock.opblock-delete {
          border-color: #dc3545;
          background: #fff5f5;
        }
        .swagger-ui .btn.authorize {
          background-color: #007bff;
          border-color: #007bff;
        }
        .swagger-ui .btn.authorize:hover {
          background-color: #0056b3;
          border-color: #0056b3;
        }
        .swagger-ui .response-col_status {
          font-weight: 600;
        }
        .swagger-ui .response-col_links {
          min-width: 6em;
        }
        .swagger-ui .parameter__name {
          font-weight: 600;
        }
        .swagger-ui .model-title {
          font-weight: 600;
        }
        .code-generator-container {
          margin-top: 10px;
          padding: 10px;
          background: #f8f9fa;
          border-radius: 4px;
          text-align: right;
        }
        .btn-generate-code {
          padding: 8px 16px;
          background: #007bff;
          color: #fff;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: background-color 0.3s;
        }
        .btn-generate-code:hover {
          background: #0056b3;
        }
        .swagger-ui .opblock {
          margin-bottom: 20px;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        .swagger-ui .opblock-summary {
          padding: 15px;
        }
        .swagger-ui .opblock-body {
          padding: 20px;
        }
        .swagger-ui .opblock-description-wrapper {
          margin: 15px 0;
        }
        .swagger-ui .parameters-container {
          margin: 20px 0;
        }
        .swagger-ui .parameter {
          margin-bottom: 15px;
          padding: 10px;
          background: #fff;
          border-radius: 4px;
          border: 1px solid #e0e0e0;
        }
        .swagger-ui .response {
          margin-top: 20px;
        }
        .swagger-ui .response-col_status {
          font-weight: 600;
          color: #333;
        }
        .swagger-ui .response-col_description {
          color: #666;
        }
        .swagger-ui .response-content-type {
          font-size: 12px;
          color: #999;
        }
        .swagger-ui .highlight-code {
          background: #f5f5f5;
          padding: 10px;
          border-radius: 4px;
          margin: 10px 0;
        }
        .swagger-ui .scheme-container {
          background: linear-gradient(to right, #f8f9fa, #fff);
          padding: 20px;
          border-radius: 4px;
          margin: 20px 0;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
        .swagger-ui .info {
          margin: 30px 0;
          padding: 20px;
          background: #fff;
          border-radius: 4px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
        .swagger-ui .info .title {
          font-size: 28px;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;
        }
        .swagger-ui .info .description {
          color: #666;
          line-height: 1.6;
        }
        .swagger-ui .btn {
          border-radius: 4px;
          transition: all 0.3s;
        }
        .swagger-ui .btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .swagger-ui .btn.execute {
          background: #28a745;
          border-color: #28a745;
        }
        .swagger-ui .btn.execute:hover {
          background: #218838;
          border-color: #218838;
        }
        .swagger-ui .btn.cancel {
          background: #6c757d;
          border-color: #6c757d;
        }
        .swagger-ui .btn.cancel:hover {
          background: #5a6268;
          border-color: #5a6268;
        }
      `;
      document.head.appendChild(style);
    },
  },
  beforeDestroy() {
    // 清理
    const swaggerContainer = document.getElementById("swagger-ui");
    if (swaggerContainer) {
      swaggerContainer.innerHTML = "";
    }
  },
};
</script>

<style scoped>
.openapi-container {
  min-height: 600px;
  padding: 20px 0;
}

.swagger-ui-wrapper {
  width: 100%;
}

.code-block {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin: 10px 0;
  overflow-x: auto;
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
  max-height: 500px;
  overflow-y: auto;
}

.code-block code {
  background: transparent;
  padding: 0;
  border: none;
  color: inherit;
  white-space: pre;
  word-wrap: normal;
}
</style>

<style>
/* 全局样式，用于Swagger UI */
.swagger-ui .code-generator-container {
  margin-top: 15px;
  padding: 15px;
  background: linear-gradient(to right, #f8f9fa, #fff);
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  text-align: right;
}

.swagger-ui .btn-generate-code {
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.swagger-ui .btn-generate-code:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.4);
}

.swagger-ui .btn-generate-code:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}
</style>

